import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';

import CustomTittle from '../../../components/Elements/customTittle/customTittle';
import CustomButtons from '../../../components/Elements/Buttons/customButton';
import Header from '../../../components/Elements/header/header';
import CourseDetail from '../../coursDetail/courseDetail';
import UserDetailPopUp from '../../../components/Elements/userDetailPopUp/userDetailPopUp';
import './thankYou.css';
 
const ThankYou = (props) => {
    
    const [header, setHeader] = useState("/  PROCES ZAKUPU KURSU")
    const [isDisable, setIsDisable] = useState(true)
    const start = localStorage.getItem("youStart")
    const courseDetail = JSON.parse(localStorage.getItem("coursesHeadings"))
    const installment = JSON.parse(localStorage.getItem("installment"))
    const coupon = localStorage.getItem("Coupon")
    const payAmount = localStorage.getItem("summary")
    const amount = localStorage.getItem("amount")
    const guid = localStorage.getItem("guid")
    const link = window.location.href
    

function goToEds(){
    window.location.replace("https://egurrola.com/thank-you-page/ ")
}
window.dataLayer = window.dataLayer || [];


class DatalayerListener {
    constructor(name) {
        this.name = name;
    }
    notify(args) {
        setIsDisable(false)
        setTimeout(()=>{window.location.replace("https://egurrola.com/thank-you-page/ ")}, 10000)
    }
}

const listener1 = new DatalayerListener('listener1');




useEffect(()=>{
    
    window.dataLayer = window.dataLayer || [];
//     const originalPush = window.dataLayer.push
// const dataLayerListeners = [];
// window.dataLayer.push = function(...args) {

//     dataLayerListeners.forEach(listener => listener.notify())
    
//originalPush({
    //     originalPush({
    //         "event": 'purchase',           
    //         "ecommerce": {
    //           "currency": 'PLN',
    //           "value": payAmount,                      
    //           "transaction_id": guid,
    //           "coupon": coupon,         
    //             "items": [{
    //                       "item_name": courseDetail.courseDanceStyle,
    //                   "item_id": courseDetail.coursesHeadingsID,
    //             "item_category":  courseDetail.courseAgeRanges,
    //             "item_category2": courseDetail.courseLevel,
    //             "item_category3": courseDetail.localizationName,
    //             "item_category4": courseDetail.instructorsList,
    //             "price": installment.body.currentPrice.toFixed(2),
    //             "quantity": 1
    //           }]
    //         }
    //     });
    // }
    // dataLayerListeners.push(listener1);
    
        window.dataLayer.push({
            "event": 'purchase',           
            "ecommerce": {
              "currency": 'PLN',
              "value": amount, 
              "value_payed": payAmount,                    
              "transaction_id": guid,
              "coupon": coupon,         
                "items": [{
                          "item_name": courseDetail.courseDanceStyle,
                      "item_id": courseDetail.coursesHeadingsID,
                "item_category":  courseDetail.courseAgeRanges,
                "item_category2": courseDetail.courseLevel,
                "item_category3": courseDetail.localizationName,
                "item_category4": courseDetail.instructorsList,
                "price": installment.body.currentPrice.toFixed(2),
                "quantity": 1
              }]
            }
        });
    
//dataLayerListeners.push(listener1);
    if(!link.includes("CampThankYou")){
    
    window.dataLayer.push({
        "event": 'purchase',           
        "ecommerce": {
          "currency": 'PLN',
          "value": amount,  
          "value_payed": payAmount,                      
          "transaction_id": guid,
          "coupon": coupon,         
            "items": [{
                      "item_name": courseDetail.courseDanceStyle,
                  "item_id": courseDetail.coursesHeadingsID,
            "item_category":  courseDetail.courseAgeRanges,
            "item_category2": courseDetail.courseLevel,
            "item_category3": courseDetail.localizationName,
            "item_category4": courseDetail.instructorsList,
            "price": installment.body.currentPrice.toFixed(2),
            "quantity": 1
          }]
        }
    });}
    setTimeout(()=>{window.location.replace("https://egurrola.com/thank-you-page/ ")}, 10000)
  
},[])
    return <> 
    <Header >{header}</Header>
            {link.includes("CampThankYou")?<div className="summaryEndWraperCamp">
                <div  className="sectionWraperCamp">
                    <div  className="CampdET CampdETMsg">
                        <p className="tittle_register tittleChangePassSucces">DZIĘKUJEMY ZA ZAKUP OBOZU!</p>
                        <p className=" tittleChangePassSucces">Na twoją skrzynkę mailową wysłaliśmy niezbędne dokument</p>
                        <div className="margin-top-32">
                            <CustomButtons clickFunction={goToEds} size="small" classButton="solid"  isDisable={isDisable}>DALEJ</CustomButtons>
                        </div>   
                    </div>
                    
                    <div  className="CampdET CampdETdisplayleft">
                    <div className='columDetials_wrapper'>
                        <CustomTittle>Szczegóły zamówienia  </CustomTittle>
                        <CourseDetail forceDisplay={true}   setHeader={(e)=>{setHeader(e)}} header={header}></CourseDetail>
                    </div> </div>
                </div>
                
            </div>  
                :<div className="summaryEndWraper">
                    <main className="margin-top-64">
                            <div className="tittle_wraper">
                                <p className="tittle_register tittleChangePassSucces">DO ZOBACZENIA NA NAJBLIŻSZYCH ZAJĘCIACH</p>
                            </div>
                        
                        </main>
                        <CourseDetail forceDisplay={true}   setHeader={(e)=>{setHeader(e)}} header={header}></CourseDetail>
                        <UserDetailPopUp
                            onclick={() => {
                       
                            }}
                            title="Data rozpoczęcia:"
                            label={
                                start?.split('-')[2] +
                                '-' +
                                start?.split('-')[1] +
                                '-' +
                                start?.split('-')[0]
                            }
                         
                        ></UserDetailPopUp>:""}
                        <div className="margin-top-32">
                            <CustomButtons clickFunction={goToEds} size="big" classButton="solid"  isDisable={isDisable}>PRZEJDŹ DO STRONY GŁÓWNEJ</CustomButtons>
                        </div>        
            </div>}
    </>;
    }

export default ThankYou;
